import { render, staticRenderFns } from "./EditListedPunishmentModal.vue?vue&type=template&id=4698ff4e&scoped=true&"
import script from "./EditListedPunishmentModal.vue?vue&type=script&lang=js&"
export * from "./EditListedPunishmentModal.vue?vue&type=script&lang=js&"
import style0 from "./EditListedPunishmentModal.vue?vue&type=style&index=0&id=4698ff4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4698ff4e",
  null
  
)

export default component.exports